import { FC, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AlertAlignment, AlertTypes, closeAlert } from '../../../store/alert';
import { Button } from '../../ui';
import { CloseIcon } from '../icons';
import { Root } from './style';

export interface AlertProps {
  children: React.ReactNode;
  type: AlertTypes;
  autoClose: boolean;
  alignment: AlertAlignment;
}

const Alert: FC<AlertProps> = ({ children, type, autoClose, alignment }) => {
  const dispatch = useDispatch();

  const close = useCallback(() => {
    dispatch(closeAlert());
  }, [dispatch]);

  useEffect(() => {
    const timeToClose = type === AlertTypes.Success ? 5000 : 10000;
    if (autoClose) {
      const timer = setTimeout(() => {
        close();
      }, timeToClose);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [dispatch, autoClose, close, type]);

  return (
    <Root type={type} alignment={alignment}>
      {children}
      <Button ghost onClick={close} style={{ height: 'fit-content', alignSelf: 'center' }}>
        <CloseIcon color="white" width="10" />
      </Button>
    </Root>
  );
};

export default Alert;
